import {meetingsAdapter, suggestionsAdapter, timeZonesAdapter} from './adapters';
import {MeetingsSliceState} from './types';

export const getInitialState = (): MeetingsSliceState => ({
  settings: {
    enabledCalendarIntegration: false,
    pageTimespanInDays: 0,
    enabledGoogleWorkspace: false,
    enabledOffice365: false,
    onlineMeetingLinkSupported: true,
  },
  userPreferences: {
    enableCalendar: false,
    userClosedConsentTile: false,
    userClosedConsentErrorTile: false,
    workingHours: null,
    calendarDomain: null,
  },
  items: meetingsAdapter.getInitialState(),
  meetingPreferencesLoadingStatus: 'NotLoaded',
  selectedMeetingId: '',
  selectedMeetingAttendeeGroupId: '',
  isUserCalendarConsentInvalid: false,
  meetingsLoadingStatus: {},
  lastRequestedISODate: '',
  lastVisibleISODate: '',
  isUpdatingCalendarConsent: false,
  isUpdatingMeetingUserPreferences: false,
  suggestions: suggestionsAdapter.getInitialState(),
  meetingCreationStatus: 'NotLoaded',
  meetingSuggestionLoadingStatus: 'NotLoaded',
  meetingInviteeSearchResults: [],
  inviteeSearchLoadingStatus: 'NotLoaded',
  isDeleting: false,
  timeZones: timeZonesAdapter.getInitialState(),
  areTimeZonesLoading: false,
  attendeeAvailabilityLoadingStatus: 'NotLoaded',
  currentAttendeeAvailabilities: [],
  meetingUpdateLoadingStatus: 'NotLoaded',
});
